<script>
const ALLOWED = new Set([
  'p', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'ul', 'ol', 'li',
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'a', 'blockquote', 'div', 'span',
  'img', 'pre', 'code', 'hr', 'sub', 'sup', 'figure', 'figcaption',
]);

function safeUrl(value, allowMailto) {
  const raw = String(value || '').trim();
  if (!raw) return '';
  if (raw.startsWith('/') && !raw.startsWith('//') && !raw.startsWith('/\\')) return raw;
  try {
    const url = new URL(raw, 'https://gively.local');
    if (url.protocol === 'https:' || url.protocol === 'http:') return url.href;
    if (allowMailto && url.protocol === 'mailto:') return raw;
  } catch (e) {
    return '';
  }
  return '';
}

function renderChildren(h, node) {
  const out = [];
  Array.from(node.childNodes || []).forEach(child => {
    if (child.nodeType === 3) {
      if (child.textContent) out.push(child.textContent);
      return;
    }
    if (child.nodeType !== 1) return;
    const tag = child.tagName.toLowerCase();
    if (tag === 'br' || tag === 'hr') {
      out.push(h(tag));
      return;
    }
    if (!ALLOWED.has(tag)) {
      out.push(...renderChildren(h, child));
      return;
    }
    if (tag === 'a') {
      const href = safeUrl(child.getAttribute('href'), true);
      if (!href) {
        out.push(...renderChildren(h, child));
        return;
      }
      out.push(h('a', {
        attrs: { href, rel: 'noopener noreferrer nofollow', target: '_blank' },
      }, renderChildren(h, child)));
      return;
    }
    if (tag === 'img') {
      const src = safeUrl(child.getAttribute('src'), false);
      if (!src) return;
      out.push(h('img', {
        attrs: { src, alt: child.getAttribute('alt') || '' },
        style: { maxWidth: '100%' },
      }));
      return;
    }
    out.push(h(tag, renderChildren(h, child)));
  });
  return out;
}

export default {
  name: 'SafeRichText',
  functional: true,
  props: {
    html: {
      type: String,
      default: '',
    },
  },
  render(h, context) {
    const html = context.props.html || '';
    if (!html || typeof DOMParser === 'undefined') {
      return h('div', { class: context.data.class }, html);
    }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return h('div', { class: context.data.class }, renderChildren(h, doc.body));
  },
};
</script>
